import { EventsBySportIdRequest } from "sb-bff-integration";
export const mapStatisticsIcon = (shouldShowStatistics, ev) => {
    ev.statisticsIcon = {
        active: (shouldShowStatistics
            && ev.tags.indexOf(EventsBySportIdRequest.EventTagsEnum.Stats.toString()) > -1),
        tooltip: "Statistics"
    };
    return ev;
};
//# sourceMappingURL=mapStatisticsIcon.js.map